<template>
  <aside
    :class="[
      'v2-sidebar',
      {
        'v2-sidebar--mobile-open': mobileOpen,
      }
    ]"
  >
      <div class="v2-sidebar__inner">
        <ProfileCard
          v-if="user && (user.role === 'MEMBER' || user.role === 'MEMBERSHIP_USER')"
          :user="user"
          :collapsed="false"
          @click.native="onNav"
        />

        <nav class="v2-sidebar__nav" aria-label="Navegación principal">
          <ul class="v2-sidebar__list">
            <li
              v-for="item in items"
              :key="item.route || item.title"
              class="v2-sidebar__item"
            >
              <NavItem
                :label="item.title"
                :to="item.route"
                :icon="item.icon"
                :disabled="Boolean(item.disabled)"
                :external="Boolean(item.external)"
                :collapsed="false"
                variant="navy"
                active-match="prefix"
                @click="onNav"
              />
            </li>
          </ul>
        </nav>

        <footer class="v2-sidebar__footer">
          <button
            type="button"
            class="v2-sidebar__logout"
            @click="onLogout"
          >
            <v-icon size="20" class="v2-sidebar__logout-icon">mdi-logout</v-icon>
            <span class="v2-sidebar__logout-label">Cerrar sesión</span>
          </button>
</footer>
      </div>
  </aside>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import NavItem from "./NavItem.vue";
import ProfileCard from "./ProfileCard.vue";
import { resolveMemberNavItems } from "@/views/memberDashboardV2/shell/navItems";

export default {
  name: "AppSidebar",
  components: { NavItem, ProfileCard },
  props: {
    mobileOpen: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false },
    collapsed: { type: Boolean, default: false },
  },
  computed: {
    ...mapState("user", ["user"]),
    items() {
      return resolveMemberNavItems(this.user);
    },
  },
  methods: {
    ...mapMutations("member", ["delItems"]),
    ...mapMutations("membershipProfile", ["removeMembershipProfile"]),
    ...mapActions("user", ["logout"]),
    ...mapActions("member", ["deleteMemberItems"]),
    onNav() {
      this.$emit("nav");
    },
    async onLogout() {
      try {
        if (typeof this.deleteMemberItems === "function") {
          await this.deleteMemberItems();
        }
      } catch (e) {
        // continue with logout even if cleanup fails
      }
      try {
        if (typeof this.removeMembershipProfile === "function") {
          this.removeMembershipProfile();
        }
      } catch (e) {
        // continue with logout even if cleanup fails
      }
      try {
        await this.logout();
      } catch (e) {
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style scoped>
.v2-sidebar {
  width: 100%;
  height: 100%;
  background: var(--gradient-chamber);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--color-navy-on);
}

.v2-sidebar__inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  width: 100%;
  padding-top: var(--space-4);
}

.v2-sidebar__nav {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-4) 0;
  scrollbar-width: thin;
  scrollbar-color: var(--color-navy-light) transparent;
}

.v2-sidebar__nav::-webkit-scrollbar {
  width: 4px;
}

.v2-sidebar__nav::-webkit-scrollbar-track {
  background: transparent;
}

.v2-sidebar__nav::-webkit-scrollbar-thumb {
  background-color: var(--color-navy-light);
  border-radius: var(--radius-full);
}

.v2-sidebar--mobile-open .v2-sidebar__nav {
  padding: var(--space-4) var(--space-2);
}

.v2-sidebar__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.v2-sidebar__item {
  margin: 0;
  width: 100%;
}

.v2-sidebar__footer {
  flex-shrink: 0;
  padding: var(--space-4) 0 var(--space-4);
  border-top: 1px solid rgba(255, 255, 255, 0.10);
}

.v2-sidebar__logout {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  padding: var(--space-3) var(--space-6);
  margin: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
  color: var(--color-navy-on-soft);
  font-family: var(--font-body);
  font-size: var(--fs-body-sm);
  font-weight: var(--fw-medium);
  text-align: left;
  cursor: pointer;
  transition: color var(--transition-fast), background-color var(--transition-fast);
}

.v2-sidebar__logout:hover {
  color: var(--color-error);
  background-color: rgba(186, 26, 26, 0.10);
}

.v2-sidebar__logout:focus-visible {
  outline: 2px solid var(--color-amber);
  outline-offset: -2px;
}

.v2-sidebar__logout-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v2-sidebar__logout-icon {
  flex-shrink: 0;
  color: inherit !important;
  fill: currentColor;
}
</style>
